import { State } from "../../../Reducers"
import { getValueById } from "../../../Models/Client/RemoteData"
import { APIAppTemplateModel } from "../../../Models/API/AppTemplateModel"
import { APIAppInstanceModel } from "../../../Models/API/AppInstanceModel"
import { hasValue, getValue } from "../../../Models/Client/FetchState"

export function selectTemplate(state: State): APIAppTemplateModel | undefined {
    const onboarding = state.api.interface.templateInstantiate

    if (onboarding === null) {
        return undefined
    }

    return getValueById(state.api.templates, onboarding.templateIdentifier)
}

export function selectInstance(state: State): APIAppInstanceModel | undefined {
    const onboarding = state.api.interface.templateInstantiate

    if (onboarding === null || onboarding.instanceID === undefined) {
        return undefined
    }

    return getValueById(state.api.apps.apps, onboarding.instanceID)
}

export function selectLastJobID(state: State): string | undefined {
    const onboarding = state.api.interface.templateInstantiate

    if (onboarding === null || onboarding.instanceID === undefined) {
        return undefined
    }

    const jobUUIDs = onboarding.jobAttempts
    const jobUUID =
        jobUUIDs.length > 0 ? jobUUIDs[jobUUIDs.length - 1] : undefined

    if (jobUUID === undefined) {
        return
    }

    const job = state.api.jobs.table[onboarding.instanceID]?.records.find(
        r => hasValue(r) && r.value.uuid === jobUUID
    )

    return getValue(job)?.id
}

export function selectLastJobUUID(state: State): string | undefined {
    const onboarding = state.api.interface.templateInstantiate

    if (onboarding === null || onboarding.instanceID === undefined) {
        return undefined
    }

    const jobUUIDs = onboarding.jobAttempts
    return jobUUIDs.length > 0 ? jobUUIDs[jobUUIDs.length - 1] : undefined
}
